import styled from 'styled-components'

export const StyledContainer = styled.div`
  max-width: 1200px;
  padding: 0 15px;
  height: 100%;
  margin: 0 auto;
`
